import { render, staticRenderFns } from "./transferManageEdit.vue?vue&type=template&id=cbc475e2&scoped=true"
import script from "./transferManageEdit.vue?vue&type=script&lang=js"
export * from "./transferManageEdit.vue?vue&type=script&lang=js"
import style0 from "./transferManageEdit.vue?vue&type=style&index=0&id=cbc475e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbc475e2",
  null
  
)

export default component.exports